import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { ListWidgetComponent } from '../list-widget/list-widget.component';
import { ImageWidgetComponent } from '../image-widget/image-widget.component';
import { IconComponent } from '@outlaw/icons';
import { CalendarWidget } from '../../../../interfaces/widgets';
import { transformImageWidget } from '../../util/image-widget.transform';

@Component({
  selector: 'ol-calendar-events-widget',
  imports: [ListWidgetComponent, ImageWidgetComponent, IconComponent],
  templateUrl: './calendar-events-widget.component.html',
  styleUrls: ['./calendar-events-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarEventsWidgetComponent {
  widget = input<CalendarWidget | undefined>(undefined);
  limit = input<number | undefined>(undefined);
  headerLink = input<string>('');

  title = computed(() => this.widget()?.title || '');
  events = computed(() => this.widget()?.events || []);

  processedEvents = computed(() => {
    const events = this.events().map(widget => transformImageWidget(widget));
    const limit = this.limit();
    return limit ? events.slice(0, limit) : events;
  });
}
